export interface ReportReason {
  id: number;
  entity_type: string;
  code: string;
  label: string;
  is_active: boolean;
  sort_order: number;
}

export interface ReportContentPayload {
  reason_id: number;
  severity?: number | null;
  details?: string;
  file_ids?: File[];
}
export interface ReportSubmitPayload {
  reason_id: number;
  severity?: number | null;
  details?: string;
  file_ids?: number[];
  entity_id: number | string;
  entity_type: EntityType;
}

export enum EntityType {
  NOTIFICATION = 'notification',
  FILE = 'file',
  EMAIL = 'email',
  NOTE = 'note',
  BUSINESS = 'business',
}

export interface UserReportFiles {
  file_name: string;
  file_url: string;
  file_id: number;
  download_url?: string;
}
export interface Report {
  id: number;
  entity_type: string;
  entity_id: number | string;
  details: string;
  severity: number;
  severity_label: string;
  status: string;
  created_at: string;
  reason_id: number;
  reason_code: string;
  reason_label: string;
  files: UserReportFiles[];
  reporter?: Reporter;
  resolution_notes: string;
}

export interface Reporter {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}

export interface ReportFile {
  url: string;
  blob_name: string;
  file_id: number;
}

export interface ReportContentData {
  entityType: EntityType;
  entityId: string | number;
  title: string;
  itemTitle: string;
}

export interface EditForm {
  severity: null | number;
  status: null | string;
  resolution_notes: string;
}

export interface UserInfo {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
}

export interface ConnectionInfo {
  id: number;
  connection_name: string;
  display_name: string;
}

export interface ReportEntityDetails {
  entity_type: string;
  entity_id: string | number;
  user: UserInfo | null;
  connection: ConnectionInfo | null;
  details: Record<string, string> | null;
}

export const ReportSeverityOptions = [
  { label: 'Low', value: 1 },
  { label: 'Medium', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
];

export const SeverityOptions = [
  { label: 'All Severities', value: null },
  ...ReportSeverityOptions,
];

export const StatusOptions = [
  { label: 'All Statuses', value: null },
  { label: 'Submitted', value: 'submitted' },
  { label: 'Under Review', value: 'under_review' },
  { label: 'Resolved', value: 'resolved' },
  { label: 'Dismissed', value: 'dismissed' },
];

export const EntityOptions = [
  { label: 'All Entities', value: null },
  { label: 'Business', value: EntityType.BUSINESS },
  { label: 'Note', value: EntityType.NOTE },
  { label: 'File', value: EntityType.FILE },
  { label: 'Notification', value: EntityType.NOTIFICATION },
  { label: 'Email', value: EntityType.EMAIL },
];
